import { useSuspenseQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { groupHistory } from "../group-history";
import { chatHistoryQueryOptions } from "../query-options";

export function useChatHistoryGroups({
  baseUrl,
  viewerId,
  chatId,
}: {
  baseUrl: string;
  viewerId: string;
  chatId?: string;
}) {
  const { data: history } = useSuspenseQuery(
    chatHistoryQueryOptions({ baseUrl, viewerId })
  );

  const groups = useMemo(
    () =>
      groupHistory(
        history.map((item) => ({ ...item, isActive: item.id === chatId }))
      ),
    [history, chatId]
  );

  return { groups };
}
